import { render, staticRenderFns } from "./PaymentsAdmin.vue?vue&type=template&id=86b8c660&"
import script from "./PaymentsAdmin.vue?vue&type=script&lang=js&"
export * from "./PaymentsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports